/* eslint-disable */

export const configuredVolume = {
    GET_CONFIGURED_VOLUME_REQUEST: 'GET_CONFIGURED_VOLUME_REQUEST',
    GET_CONFIGURED_VOLUME_SUCCESS: 'GET_CONFIGURED_VOLUME_SUCCESS',
    CONFIGURED_VOLUME_FAILURE: 'CONFIGURED_VOLUME_FAILURE',
};
